module.exports = __webpack_public_path__ + "static/media/check.664a36b6.svg";